import React from 'react';
import Navbar from './navbar';
import Footer from './footer';
import Contact from './contact';
import arrowIcon from "../images/home/arrow-icon.svg";
import { Helmet } from "react-helmet-async";

const PrivacyPolicy = () => {
  return (
    <div>
      <Helmet>
        <title>Privacy Policy | Immiget Global Australia</title>
        <meta
          name="description"
          content="Privacy Policy for Immiget Global Australia immigration services."
        />
      </Helmet>

      <Navbar />

      {/* Banner Section */}
      <div className="w-full h-90 font-Hellix bg-cover bg-center bg-image">
        <div className="max-w-[1440px] px-4 md:px-[75px] m-auto h-full">
          <div className="flex flex-col gap-2 md:gap-2 pt-10 md:pt-20 pb-[90px] h-full justify-center">
            <div className="text-white hellix-font text-center font-semibold text-[22px] md:text-[54px]">
              Privacy Policy
            </div>
            <div className="flex justify-center gap-2 md:gap-4">
              <div className="text-white hellix-font text-[10px] lg:text-sm flex items-center md:text-lg font-medium">
                HOME
              </div>
              <div className="flex items-center">
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
              </div>
              <div className="text-white hellix-font text-[10px] lg:text-sm flex items-center md:text-lg font-medium uppercase">
                Privacy Policy
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Content Section */}
      <div className="container max-w-1440px mx-auto px-4 py-10 lg:px-14">
        <div className="max-w-none">
          <h1 className="text-3xl md:text-5xl font-semibold hellix-font text-[#004B6B] mb-8">Privacy Policy for Immiget Global</h1>
          <p className="text-base md:text-lg text-gray-800 hellix-font leading-relaxed mb-6">
            At Immiget Global, accessible from immigetglobal.com, one of our main priorities is the privacy of our visitors. This Privacy Policy document contains types of information that is collected and recorded by Immiget Global and how we use it. If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us through email at{" "}
            <a href="mailto:connect@immigetglobal.com" className="text-[#004B6B] hover:underline">
              connect@immigetglobal.com
            </a>.
          </p>

          <h2 className="text-2xl md:text-3xl font-semibold hellix-font text-[#004B6B] mt-10 mb-5">Log Files</h2>
          <p className="text-base md:text-lg text-gray-800 hellix-font leading-relaxed mb-6">
            Immiget Global follows a standard procedure of using log files. These files log visitors when they visit websites. All hosting companies do this and a part of hosting services' analytics. The information collected by log files include internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks. These are not linked to any information that is personally identifiable. The purpose of the information is for analyzing trends, administering the site, tracking users' movement on the website, and gathering demographic information.
          </p>

          <h2 className="text-2xl md:text-3xl font-semibold hellix-font text-[#004B6B] mt-10 mb-5">Cookies and Web Beacons</h2>
          <p className="text-base md:text-lg text-gray-800 hellix-font leading-relaxed mb-6">
            Like any other website, Immiget Global uses 'cookies'. These cookies are used to store information including visitors' preferences, and the pages on the website that the visitor accessed or visited. The information is used to optimize the users' experience by customizing our web page content based on visitors' browser type and/or other information.
          </p>

          <h2 className="text-2xl md:text-3xl font-semibold hellix-font text-[#004B6B] mt-10 mb-5">Third Party Privacy Policies</h2>
          <p className="text-base md:text-lg text-gray-800 hellix-font leading-relaxed mb-6">
            Immiget Global's Privacy Policy does not apply to other advertisers or websites. Thus, we are advising you to consult the respective Privacy Policies of these third-party ad servers for more detailed information. It may include their practices and instructions about how to opt-out of certain options. You can choose to disable cookies through your individual browser options. To know more detailed information about cookie management with specific web browsers, it can be found at the browsers' respective websites.
          </p>

          <h2 className="text-2xl md:text-3xl font-semibold hellix-font text-[#004B6B] mt-10 mb-5">Children's Information</h2>
          <p className="text-base md:text-lg text-gray-800 hellix-font leading-relaxed mb-6">
            Another part of our priority is adding protection for children while using the internet. We encourage parents and guardians to observe, participate in, and/or monitor and guide their online activity. Immiget Global does not knowingly collect any Personal Identifiable Information from children under the age of 18. If you think that your child provided this kind of information on our website, we strongly encourage you to contact us immediately and we will do our best efforts to promptly remove such information from our records.
          </p>

          <h2 className="text-2xl md:text-3xl font-semibold hellix-font text-[#004B6B] mt-10 mb-5">Online Privacy Policy Only</h2>
          <p className="text-base md:text-lg text-gray-800 hellix-font leading-relaxed mb-6">
            This Privacy Policy applies only to our online activities and is valid for visitors to our website with regards to the information that they shared and/or collect in Immiget Global. This policy is not applicable to any information collected offline or via channels other than this website.
          </p>

          <h2 className="text-2xl md:text-3xl font-semibold hellix-font text-[#004B6B] mt-10 mb-5">Consent</h2>
          <p className="text-base md:text-lg text-gray-800 hellix-font leading-relaxed mb-6">
            By using our website, you hereby consent to our Privacy Policy and agree to its Terms and Conditions.
          </p>
        </div>
      </div>

      <Contact />
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;